import cn from 'classnames';
import Image from 'next/legacy/image';
import { memo } from 'react';
import ImageCat from '../../assets/Image_cat.jpg';
import ImageDog from '../../assets/image_dog.jpg';
import UnionDesktop from '../../assets/union-desktop.svg';
import UnionMobile from '../../assets/union-mobile.svg';

interface Props {
  petType: 'dog' | 'cat';
}

/**
 * Image Section of the NeedCapture component
 */
const ImageSection: React.FC<Props> = ({ petType }) => (
  <>
    {/* Image Mobile */}
    <div className="relative lg:hidden">
      <div className="-mt-20">
        <Image
          src={petType === 'dog' ? ImageDog : ImageCat}
          quality={100}
          priority
          layout="responsive"
          width={1232}
          height={928}
          objectFit="cover"
          objectPosition="center center"
          data-test="need-capture-dog-image-mobile"
        />
      </div>
      <UnionMobile
        className={cn(
          'absolute -bottom-1',
          petType === 'dog' ? 'text-dog-base' : 'text-cat-base'
        )}
      />
    </div>
    {/* Image Desktop */}
    <div className="absolute top-0 right-0 hidden h-80 w-[30%] overflow-hidden lg:block xl:w-2/5">
      <Image
        src={petType === 'dog' ? ImageDog : ImageCat}
        quality={100}
        priority
        layout="fill"
        objectFit="cover"
        data-test="need-capture-dog-image-desktop"
      />
      <UnionDesktop
        className={cn(
          'absolute bottom-0 left-0 h-full scale-[1.01]',
          petType === 'dog' ? 'text-dog-base' : 'text-cat-base'
        )}
      />
    </div>
  </>
);

export default memo(ImageSection);
